<template>
  <div class="">
    <div class="header">
      <img src="@/assets/logo2024_7_26 10_55_51.png" width="50px" alt="Logo" />
      <div class="header-title">
        <span class="brand-name">Kester</span>
        <span class="subtitle">{{ $t(`${["信息验证"]}`) }}</span>
      </div>
    </div>
    <!-- 授权成功的页面 -->
    <div class="flex flex-col items-center justify-center w-full h-screen">
      <img src="@/assets/773d029c70c2b66877eab2adfca9aac9.png" alt="" class="w-1/2" />
      <h1 class="text-lg font-bold m-5">{{ $t("授权成功") }}</h1>
      <button class="mt-4 bg-blue-500 text-white px-4 py-2 rounded-md" @click="closePage">
        {{ $t("手动跳转") }}
      </button>
    </div>
    <!-- 模糊背景 -->
  </div>
</template>

<script>
export default {
  name: "OperatorVueClientSuccess",

  data() {
    return {};
  },

  mounted() {
      setTimeout(() => {
        this.closePage();
      }, 3000);
  },
  methods: {
    closePage() {
      //跳转到第三方的页面
      if (this.$route.query.callBack) {
        window.location.href = this.$route.query.callBack;
      } else {
        //关闭当前页面
        if (localStorage.getItem("referrer")) {
          window.location.href = localStorage.getItem("referrer");
        }
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.header {
  width: 100%;
  height: 100px;
  background: url("../assets/nen_bg.png");
  background-size: cover;
  background-position: top;
  background-repeat: no-repeat;
  padding-top: 16px;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-bottom: 20px;
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: 1000;
}

.header-title {
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-left: 10px;
}

.brand-name {
  font-size: 1.5rem;
  font-weight: bold;
  color: #3b82f6;
  letter-spacing: 0.1em;
}

.subtitle {
  font-size: 0.75rem;
  color: #3b82f6;
}

.auth-form {
  padding: 0 16px;
}
</style>
